import {
    Component,
    OnDestroy,
    OnInit,
    TemplateRef,
    inject,
    viewChild,
    computed,
    Signal,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ResearcherAsset } from '../../shared/interfaces/researcher-asset.interface';
import { ResourceTypeModel } from '../../shared/interfaces/resource-type.model';
import { ResourceTypeUtils } from '../../shared/utils/resource-type.utils';
import {
    GrowInAnimation,
    GrowOutAnimation,
    OpacityInAnimation,
    OpacityOutAnimation,
    SlideInAnimation,
    SlideOutAnimation,
    ExportersDialogComponent,
    ExportersService,
    SeparatorComponent,
    StatusTagComponent,
    ExpandableComponent,
    FloatingToolbarComponent,
    PagingComponent,
    HtmlSanitizePipe,
    UrlTrustPipe,
} from '@exl-ng/mulo-common';
import { ResearcherAssetStatus } from '../../shared/configurations/researcher-asset-status.constant';
import { DepositFormOverlayService } from '../../deposit/deposit-form-overlay/deposit-form-overlay.service';
import { DepositFormDataService } from '../../deposit/deposit-form-data.service';
import { ProfileOutputService } from '../profile-output/profile-output.service';
import { EsploroRecord } from '../../shared/interfaces/esploro-record.model';
import { MatDialog, MatDialogClose } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../parts/dialogs/confirm-dialog/confirm-dialog.component';
import { Profile } from '../../shared/configurations/profile.constant';
import { UrlUtils } from '../../shared/utils/url.utils';
import { CalendarDate } from '../../shared/interfaces/calendar-date.model';
import { PaginationInstance, NgxPaginationModule } from 'ngx-pagination';
import { ResearcherOutputListSearchResults } from '../../shared/interfaces/researcher-output-list-search-results.interface';
import { ProfileAssetDisplayEnrichmentService } from '../profile-asset-display-enrichment.service';
import { NotificationData } from '../../shared/interfaces/researcher-notification.model';
import { AuthorizationService } from '../../core/authorization.service';
import { MediaService, SvgViewboxDirective } from '@exl-ng/mulo-core';
import { DepositFilesLinksDialogComponent } from '../../deposit/deposit-files-links-dialog/deposit-files-links-dialog.component';
import { ConfigurationHandlerService } from '../../core/configuration-handler.service';
import {
    additionalMenuItems,
    draftActions,
    draftActionsForNonAuthorized,
    menuActions,
    profileMenuItems,
} from './profile-output-manu-items';
import { NotificationService } from '../../core/notification.service';
import { JwtUtilService } from '../../core/jwt-util.service';
import { ChatDialogComponent } from '../../parts/chat/chat-dialog/chat-dialog.component';
import {
    finalize,
    map,
    Observable,
    Subject,
    Subscription,
    take,
    takeUntil,
} from 'rxjs';
import { CitationBriefComponent } from '../../parts/citations/citation-brief/citation-brief.component';
import { AssetExportService } from '../../asset-page/asset-page-export/asset-export.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { FullAssetPage } from '../../shared/configurations/full-asset-page.constant';
import { DefaultTranslatePipe } from '../../shared/pipes/default-translate.pipe';
import { ConcatPipe } from '../../shared/pipes/concat.pipe';
import { ButtonSplashComponent } from '../../bits/button-splash/button-splash.component';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton, MatMiniFabButton } from '@angular/material/button';
import { CitationBriefNotificationComponent } from '../../parts/citations/citation-brief-notification/citation-brief-notification.component';
import { AutomationClassDirective } from '../../shared/directives/tests/automation-tests-class.directive';
import { CitationBriefPlaceholderComponent } from '../../parts/citations/citation-brief-placeholder/citation-brief-placeholder.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { DepositOutputDialogComponent } from '../../deposit/deposit-output-dialog/deposit-output-dialog.component';

@Component({
    selector: 'esp-profile-output-group',
    templateUrl: './profile-output-group.component.html',
    styleUrls: ['./profile-output-group.component.scss'],
    animations: [
        SlideInAnimation,
        SlideOutAnimation,
        GrowOutAnimation,
        GrowInAnimation,
        OpacityOutAnimation,
        OpacityInAnimation,
    ],
    imports: [
        CitationBriefPlaceholderComponent,
        CitationBriefComponent,
        AutomationClassDirective,
        CitationBriefNotificationComponent,
        SeparatorComponent,
        StatusTagComponent,
        MatIconButton,
        MatTooltip,
        MatIcon,
        NgClass,
        ButtonSplashComponent,
        SvgViewboxDirective,
        ExpandableComponent,
        FloatingToolbarComponent,
        NgxPaginationModule,
        PagingComponent,
        MatMiniFabButton,
        MatDialogClose,
        TranslateModule,
        ConcatPipe,
        DefaultTranslatePipe,
        HtmlSanitizePipe,
        UrlTrustPipe,
    ],
})
export class ProfileOutputGroupComponent implements OnInit, OnDestroy {
    private route = inject(ActivatedRoute);
    private depositFormOverlay = inject(DepositFormOverlayService);
    private depositFormDataService = inject(DepositFormDataService);
    profileOutputService = inject(ProfileOutputService);
    profileAssetEnrichmentService = inject(
        ProfileAssetDisplayEnrichmentService,
    );
    private matDialog = inject(MatDialog);
    private dialog = inject(MatDialog);
    private router = inject(Router);
    private media = inject(MediaService);
    private authorizationService = inject(AuthorizationService);
    private configurationHandlerService = inject(ConfigurationHandlerService);
    notificationService = inject(NotificationService);
    private jwtUtilService = inject(JwtUtilService);
    private assetExportSvc = inject(AssetExportService);
    private exportersService = inject(ExportersService);
    private xl8Svc = inject(TranslateService);

    readonly viewDialogTmpl = viewChild<TemplateRef<any>>('viewDialog');
    readonly briefElem = viewChild<CitationBriefComponent>('briefElem');
    profileMenuItems = profileMenuItems;

    institutionCode: string;
    outputGroup;
    isLoading = false;
    facet: string;
    facetCount: number;
    facetSections = [];

    subscription: Subscription;
    assetListSubscription: Subscription;

    /* ngx-pagination options object */
    paginationConfig: PaginationInstance = {
        id: 'serverPagingOutput',
        itemsPerPage: Profile.BULK_SIZE,
        currentPage: 1,
    };

    pagesCount: number;

    notificationData: NotificationData;
    displayAltmetric: boolean;

    useAltOAIcon: Signal<boolean>;

    trackByAsset = (index: number, asset: ResearcherAsset) => asset.mmsId;

    constructor() {
        this.useAltOAIcon = computed(
            () =>
                this.configurationHandlerService.config().customerParameters?.[
                    'esploro_alt_open_access_icon'
                ] === 'true',
        );
    }

    ngOnInit() {
        this.institutionCode = UrlUtils.getParam('institution');
        let page = '';
        if (this.route.snapshot.queryParamMap) {
            page = this.route.snapshot.queryParamMap.get('page');
        }
        this.displayAltmetric =
            this.configurationHandlerService.briefDisplayAltmetrics() ||
            this.configurationHandlerService.getCustomerParameter(
                'always_display_altmetrics_in_profiles',
            ) === 'true';
        this.route.data.subscribe((data) => {
            //relevant only to the first deep link, there we set it back to empty
            if (page) {
                this.paginationConfig.currentPage = page as unknown as number;
            } else {
                this.paginationConfig.currentPage = 1;
            }
            page = '';
            this.facet = data.resourceType as unknown as string;
            this.profileOutputService.chosenFacet = this.facet;
            this.facetCount = this.getFacetNumber();
            this.isLoading = true;
            this.outputGroup = [];
            this.getAssetSummaryList();
            //   this.addPageParamToURL();
        });

        this.subscription = this.profileOutputService.refreshData$.subscribe(
            () => {
                this.getAssetSummaryList();
            },
        );
    }

    getFacetNumber() {
        for (const facet of this.profileOutputService.flattenFacetsList) {
            if (facet.facet === this.facet) {
                return parseInt(facet.count);
            }
        }
        return 0;
    }

    getNumOfCopies() {
        return Math.min(
            Profile.BULK_SIZE,
            this.facetCount -
                (this.paginationConfig.currentPage - 1) * Profile.BULK_SIZE,
        );
    }

    pageChange(event) {
        this.paginationConfig.currentPage = event;
        this.outputGroup = [];
        this.isLoading = true;
        this.getAssetSummaryList();
        this.addPageParamToURL();
    }

    get searchOffset() {
        return (this.currentPage - 1) * Profile.BULK_SIZE;
    }

    get currentPage() {
        return this.paginationConfig.currentPage;
    }

    get multiplePages() {
        return this.pagesCount > 1;
    }

    getAssetSummaryList() {
        this.assetListSubscription = this.profileOutputService
            .getAssetSummaryList(
                this.isPublicPage,
                this.facet,
                this.searchOffset,
            )
            .subscribe({
                next: (data) => {
                    this.facetSections =
                        this.profileOutputService.flattenFacetsList;

                    if (data) {
                        this.isLoading = false;
                        const searchResponse =
                            data as ResearcherOutputListSearchResults;
                        this.paginationConfig.totalItems =
                            searchResponse.totalResults;
                        //when deleting an asset, it takes time to the solr to update the status and we get declined records.
                        this.outputGroup = searchResponse.records.filter(
                            (record) =>
                                record.status !==
                                ResearcherAssetStatus.DECLINED,
                        );
                        this.pagesCount = this.calcPagesCount();
                        if (this.outputGroup && this.outputGroup.length > 0) {
                            this.enrichData();
                        }
                    } else if (
                        !data &&
                        this.paginationConfig.currentPage !== 1
                    ) {
                        this.paginationConfig.currentPage = 1;
                        this.getAssetSummaryList();
                    }
                },
                error: () => {
                    this.isLoading = false;
                },
            });
    }

    addPageParamToURL() {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { page: this.paginationConfig.currentPage },
            queryParamsHandling: 'merge',
        });
    }

    calcPagesCount() {
        return Math.ceil(this.paginationConfig.totalItems / Profile.BULK_SIZE);
    }

    enrichData() {
        this.outputGroup = this.outputGroup
            .map((item) => ({
                ...item,
                action: this.getActions(item),
                author: this.profileAssetEnrichmentService.getAuthor(item),
                menu: this.getMenu(item),
                type: this.profileAssetEnrichmentService.getType(item),
                isPartOf: this.profileAssetEnrichmentService.getIsPartOf(item),
                assetStatus: this.getStatus(item),
                dateModification: this.getDateMofification(item),
                dateLabel: this.getDateLabel(item),
                notification: this.getNotifications(item),
                notificationActions: this.getNotificationActions(),
                doi: item.doi,
                isReservedDOI: item.isReservedDOI,
                date: this.profileAssetEnrichmentService.getDateByPriority(
                    item,
                ),
                visibleInPublicProfile: item.visibleInPublicProfile,
                isAssetSuppressed: item.isAssetSuppressed,
                displayInPortal: item.displayInPortal,
                assetRelativeUrl:
                    item.displayInPortal &&
                    (this.isApprovedOrImportedAsset(item) || this.isPublicPage)
                        ? item.assetRelativeUrl
                        : '',
            }))
            .map((item) => ({
                ...item,
                lines: this.profileAssetEnrichmentService.getLines(item),
            }));
    }

    getDateMofification(item: ResearcherAsset) {
        if (this.isDraft(item)) {
            const data = item.modificationDate as CalendarDate;
            return new Date(
                Date.UTC(
                    data.year,
                    data.month,
                    data.dayOfMonth,
                    data.hourOfDay,
                    data.minute,
                    data.second,
                ),
            );
        }
        return '';
    }

    getDateLabel(item: ResearcherAsset) {
        const createdDate = item.createdDate as CalendarDate;
        const modificationDate = item.modificationDate as CalendarDate;
        if (
            createdDate.year === modificationDate.year &&
            createdDate.month === modificationDate.month &&
            createdDate.dayOfMonth === modificationDate.dayOfMonth &&
            createdDate.hourOfDay === modificationDate.hourOfDay &&
            Math.abs(createdDate.minute - modificationDate.minute) < 2
        ) {
            return 'research.output.list.date.created';
        }
        return 'research.output.list.date.modification';
    }

    getStatus(item: ResearcherAsset) {
        if (this.isDraft(item)) {
            return 'research.output.list.status.draft';
        }
        if (this.isApprovedOrImportedAsset(item)) {
            return '';
        }
        return item.statusStr;
    }

    getActions(item) {
        if (this.isDraft(item)) {
            if (this.authorizationService.isAuthorizedForDeposit()) {
                return draftActions;
            }
            return draftActionsForNonAuthorized;
        }
        return [];
    }

    isPublishedAsset(item: ResearcherAsset) {
        if (!item.isAssetSuppressed && this.isApprovedOrImportedAsset(item)) {
            return true;
        }
        return false;
    }

    isApprovedOrImportedAsset(item: ResearcherAsset) {
        if (
            item.status === ResearcherAssetStatus.APPROVED ||
            item.status === ResearcherAssetStatus.IMPORTED
        ) {
            return true;
        }
        return false;
    }

    onActionClick(action, item: ResearcherAsset, index: number) {
        switch (action) {
            case 'research.output.list.menu.edit':
                if (
                    [
                        ResearcherAssetStatus.DRAFT,
                        ResearcherAssetStatus.RETURNED,
                    ].includes(item.status)
                ) {
                    this.openDraft(item);
                } else {
                    this.navigateToFullAssetPage(item.assetRelativeUrl, true);
                }
                break;
            case 'research.output.list.menu.delete':
                this.showAssetDeleteConfirmationDialog(item, index);
                break;
            case 'research.output.list.menu.view':
                if (
                    item.displayInPortal &&
                    (this.isApprovedOrImportedAsset(item) || this.isPublicPage)
                ) {
                    this.navigateToFullAssetPage(item.assetRelativeUrl);
                } else {
                    this.openViewMode(item);
                }
                break;
            case 'research.output.list.action.unhide.asset':
                this.unhideAsset(item);
                break;
            case 'research.output.list.action.hide.asset':
                this.hideAsset(item, index);
                break;
            case 'research.output.list.action.add.files.links':
                this.openAddFilesDialog(item);
                break;
            case 'research.output.list.action.export.asset':
                this.exportAsset(item);
                break;
            case 'research.output.list.action.message.list':
                this.openMessagesDialog(item);
                break;
            case 'research.output.list.action.apc.request':
                this.openApcForm(item);
                break;
            case 'research.output.list.menu.viewChanges':
                this.navigateToFullAssetPage(
                    item.assetRelativeUrl,
                    false,
                    true,
                );
                break;
        }
    }

    openMessagesDialog(asset) {
        const dialog = this.matDialog.open(ChatDialogComponent, {
            minWidth: '400px',
            panelClass: 'esp-chat-dialog',
            data: {
                title: 'research.output.list.message.window',
                indexElement: asset.notification.index,
                model: asset,
                chat: asset.notification.notifications,
                singleInstanceChat: true,
                actions: {
                    cancel: 'research.output.list.message.window.cancel',
                    confirm: 'research.output.list.message.window.send',
                    close: true,
                },
                actionFocus: 'confirm',
            },
        });
        dialog
            .afterOpened()
            .pipe(take(1))
            .subscribe((result) => {
                this.notificationService
                    .readAllCommunicationMessage(asset.mmsId)
                    .subscribe(() => {
                        asset.notification.currNote = undefined;
                    });
            });
        dialog
            .afterClosed()
            .subscribe(() => this.briefElem().menuBtn().focus());
    }

    onNotificationAction(action, noteData, asset) {
        if (action.code === 'reply') {
            this.openMessagesDialog(asset);
        } else if (action.code === 'gotIt') {
            this.notificationService
                .readCommunicationMessage(noteData.currNote.uuid, asset.mmsId)
                .subscribe(() => {
                    noteData.currNote = undefined;
                    for (
                        let i = noteData.index + 1;
                        i < noteData.notifications.length;
                        i++
                    ) {
                        const newNote = noteData.notifications[i];
                        if (newNote.showNotification && !noteData.currNote) {
                            this.notificationService.setCurrentNote(
                                noteData,
                                i,
                                newNote,
                            );
                        }
                    }
                });
        }
    }

    onHighlightClick(item, index) {
        if (this.inHighlightsList(item)) {
            this.removeHighlight(item.mmsId, index);
        } else if (
            this.profileOutputService.highlights.length <
            Profile.HIGHLIGHTS_LIMIT
        ) {
            this.addHighlight(item.mmsId);
        } else if (
            this.profileOutputService.highlights.length >=
            Profile.HIGHLIGHTS_LIMIT
        ) {
            this.openHighlightDialogLimitation();
        }
    }

    openHighlightDialogLimitation() {
        const dialogData = this.getHighlightDialogData();
        setTimeout(() => {
            this.matDialog
                .open(ConfirmDialogComponent, dialogData)
                .afterClosed()
                .pipe(take(1))
                .subscribe((res) => {
                    if (res === 'ok') {
                        this.manageHighlightsAction();
                    }
                });
        }, 0);
    }

    manageHighlightsAction() {
        this.router.navigate(['/profile/output/highlights'], {
            relativeTo: this.route,
            queryParams: { institution: this.institutionCode },
        });
        const index = this.getHighlightsIndexInFacetsList();
        if (index !== -1) {
            this.profileOutputService.selectedIndex = index;
            this.profileOutputService.selectedIndexForMobile = index;
        }
    }

    getHighlightsIndexInFacetsList() {
        for (let i = 0; i < this.profileOutputService.facets.length; i++) {
            if (
                this.profileOutputService.facets[i].category.facet ===
                'highlights'
            ) {
                return i;
            }
        }
        return -1;
    }

    getHighlightDialogData() {
        return {
            data: {
                title: 'research.output.list.highlight.dialog.limitation.title',
                titleParam: Profile.HIGHLIGHTS_LIMIT,
                message:
                    'research.output.list.highlight.dialog.limitation.message',
                actions: {
                    confirm:
                        'research.output.list.highlight.dialog.limitation.confirm',
                    cancel: 'research.output.list.highlight.dialog.limitation.cancel',
                },
                actionFocus: 'confirm',
            },
        };
    }

    addHighlight(mmsId) {
        this.profileOutputService.highlights.push(mmsId);
        this.profileOutputService.addHighlight(mmsId).subscribe(() => {
            if (this.profileOutputService.highlights.length === 1) {
                this.refreshFacets();
            } else {
                this.updateHighlightFacetCount(1);
            }
        });
    }

    removeHighlight(mmsId, i) {
        const index = this.profileOutputService.highlights.indexOf(mmsId);
        if (index !== -1) {
            this.profileOutputService.highlights.splice(index, 1);
            if (this.facet === 'highlights' && i !== -1) {
                this.outputGroup.splice(i, 1);
            }
            this.profileOutputService.removeHighlight(mmsId).subscribe(() => {
                if (this.profileOutputService.highlights.length === 0) {
                    this.refreshFacets();
                } else {
                    this.updateHighlightFacetCount(-1);
                }
            });
        }
    }

    refreshFacets() {
        this.profileOutputService
            .getOutputListFacets(this.profileOutputService.isPublicPage())
            .subscribe((data) => {
                this.profileOutputService.saveFacets(data);
            });
    }

    updateHighlightFacetCount(numToAdd) {
        for (let i = 0; i < this.profileOutputService.facets.length; i++) {
            if (
                this.profileOutputService.facets[i].category.facet ===
                'highlights'
            ) {
                const count = (
                    parseInt(
                        this.profileOutputService.facets[i].category.count,
                    ) + numToAdd
                ).toString();
                this.profileOutputService.facets[i].category.count = count;
            }
        }
    }

    deleteAsset(item, index) {
        this.profileOutputService.deleteAsset(item).subscribe(() => {
            //when deleting an asset, it takes time to the solr to update the status, therefore we need to wait before
            //calling the server again
            setTimeout(() => {
                this.getAssetSummaryList();
            }, 2500);
        });
        this.outputGroup.splice(index, 1);
        // this.paginationConfig.totalItems = this.paginationConfig.totalItems -1;
        // this.pagesCount = this.calcPagesCount();
        this.profileOutputService.deleteAssetFromDisplay(this.facet);
        this.profileOutputService.assetDeleted$.next(true);
    }

    showAssetDeleteConfirmationDialog(item, index) {
        const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
            data: {
                title: this.isDraft(item)
                    ? 'research.output.list.delete.draft.confirmation.title'
                    : 'research.output.list.delete.asset.confirmation.title',
                message: this.isDraft(item)
                    ? 'research.output.list.delete.draft.confirmation.message'
                    : 'research.output.list.delete.asset.confirmation.message',
                actions: {
                    cancel: this.isDraft(item)
                        ? 'research.output.list.delete.draft.confirmation.cancel'
                        : 'research.output.list.delete.asset.confirmation.cancel',
                    confirm: this.isDraft(item)
                        ? 'research.output.list.delete.draft.confirmation.confirm'
                        : 'research.output.list.delete.asset.confirmation.confirm',
                },
            },
        });
        dialogRef.afterClosed().subscribe((response) => {
            this.briefElem().menuBtn().focus();
            if (response === 'ok') {
                this.deleteAsset(item, index);
            }
        });
    }

    launchDepositForm() {
        this.depositFormOverlay.open();
    }

    populateDepositForm(item: ResearcherAsset) {
        this.depositFormDataService.populateDepositFormFromEditOrView(item);
    }

    onAuthorClick() {}

    onTitleClick(item: ResearcherAsset) {
        const discoveryURL = this.profileAssetEnrichmentService.getDiscoveryURL(
            item.mmsId,
            this.institutionCode,
        );
        if (
            this.isDraft(item) ||
            item.status === ResearcherAssetStatus.RETURNED
        ) {
            this.openDraft(item);
        } else {
            this.openViewMode(item);
        }
    }

    openDraft(item) {
        this.profileOutputService.loadingDraft.set(true);
        this.depositFormDataService.isDraft.set(true);
        this.populateCategoryAndType(item);
        if (
            this.configurationHandlerService.isCustomerParameterEnabled('esploro_deposit_profiles_conf')
        ) {
            this.router.navigate(
                ['/deposit/output', this.depositFormDataService.type.value],
                {
                    queryParams: { institution: this.institutionCode },
                },
            );
        } else {
            this.launchDepositForm();
        }
        this.profileOutputService
            .getAssetByMmsId(item)
            .pipe(
                finalize(() =>
                    this.profileOutputService.loadingDraft.set(false),
                ),
            )
            .subscribe((data) => {
                const asset = data as ResearcherAsset;
                this.populateDepositForm(asset);
            });
    }

    openViewMode(item) {
        this.profileOutputService.loadingAsset = true;
        this.view(item);
    }

    view(output) {
        const dialogRef = this.dialog.open(this.viewDialogTmpl(), {
            width: '50%',
            panelClass: 'esp-view-dialog',
            data: {
                title: output.esploroRecord?.title,
                permalink: output.assetUrl,
            },
        });
        dialogRef.afterClosed().subscribe((response) => {
            this.briefElem().menuBtn().focus();
            this.depositFormDataService.resetForm();
        });
    }

    openAddFilesDialog(item) {
        const dialogRef = this.matDialog.open(
            DepositFilesLinksDialogComponent,
            {
                maxWidth: '960px',
                minHeight: '50vh',
                minWidth: '800px',
                panelClass: 'esp-full-record-dialog',
                data: {
                    mmsId: item.mmsId,
                    title: item.esploroRecord?.title,
                    type: item.type,
                },
            },
        );
        dialogRef.afterClosed().subscribe((response) => {
            this.briefElem().menuBtn().focus();
            this.depositFormDataService.resetForm();
        });
    }

    populateCategoryAndType(item) {
        const esploroRecord = item.esploroRecord as EsploroRecord;
        const resourceType =
            ResourceTypeUtils.convertEsploroRecordResourceTypeToCategoryAndType(
                esploroRecord.resourcetypeEsploro,
            ) as ResourceTypeModel;
        if (resourceType) {
            this.depositFormDataService.updateCategory(
                resourceType.getCategory(),
            );
            this.depositFormDataService.updateType(resourceType.getType());
        }
    }

    isDraft(item) {
        if (item.status === ResearcherAssetStatus.DRAFT) {
            return true;
        }
        return false;
    }

    /**
     * For now verify only hidden and approved assets
     *
     * @param item - asset
     */
    isHidden(item: ResearcherAsset) {
        if (
            (item.status === ResearcherAssetStatus.APPROVED ||
                item.status === ResearcherAssetStatus.IMPORTED) &&
            !item.visibleInPublicProfile
        ) {
            return true;
        }
        return false;
    }

    getMenu(item: ResearcherAsset) {
        if (this.isPublicPage) {
            return this.media.is('gt-xs')
                ? [
                      {
                          name: 'research.output.list.action.export.asset',
                          disabled: false,
                      },
                  ]
                : [];
        }
        let menu = [];
        let resultMenu;
        if (this.isHidden(item)) {
            menu = this.getBuildMenuAction(
                this.profileMenuItems.hiddenApprovedMenu,
            );
        } else {
            const status = item.status;

            const buildMenu = (status: string) => {
                switch (status) {
                    case ResearcherAssetStatus.RETURNED:
                        if (
                            this.authorizationService.isAuthorizedForDeposit()
                        ) {
                            if (!this.isAssetOwner(item)) {
                                resultMenu = this.profileMenuItems[
                                    status
                                ].filter(
                                    (item) =>
                                        item !== 'edit' && item !== 'delete',
                                );
                                break;
                            }
                            resultMenu = this.profileMenuItems[status];
                            break;
                        }
                        resultMenu =
                            this.profileMenuItems.returnedMenuForNonAuthorized;
                        break;
                    case ResearcherAssetStatus.DRAFT:
                        if (
                            this.authorizationService.isAuthorizedForDeposit()
                        ) {
                            resultMenu = this.profileMenuItems[status];
                            break;
                        }
                        resultMenu =
                            this.profileMenuItems.draftManuForNonAuthorized;
                        break;
                    case ResearcherAssetStatus.APPROVED:
                    case ResearcherAssetStatus.IMPORTED:
                        resultMenu = this.removeActionsFromMenu(
                            item,
                            this.profileMenuItems[status],
                        );
                        break;
                    default:
                        resultMenu = this.profileMenuItems[status] ?? [];
                }
                if (
                    ['ETD_DOCTORAL', 'ETD_GRADUATE', 'ETD_UNDERGRADUATE'].some(
                        (type) =>
                            item?.esploroRecord?.resourcetypeEsploro == type,
                    )
                ) {
                    resultMenu = resultMenu?.filter(
                        (action) => action != 'message',
                    );
                }
                return this.getBuildMenuAction(resultMenu);
            };
            menu = buildMenu(status);
        }
        if (
            this.configurationHandlerService.isCustomerParameterEnabled(
                'esploro_oable_integration',
            ) &&
            ['postedContent', 'publication', 'posted_content'].some((type) =>
                item?.esploroRecord?.resourcetypeEsploro
                    ?.toLowerCase()
                    .startsWith(type.toLowerCase()),
            )
        ) {
            menu = [...menu, additionalMenuItems.apcAction];
        }

        return menu;
    }

    getBuildMenuAction(menu: string[]) {
        return menu.map((item) => menuActions[item]);
    }

    removeActionsFromMenu(item: ResearcherAsset, menu: string[]) {
        let filteredMenu = menu;

        if (item.isAssetSuppressed) {
            const removedActions = ['hide', 'edit'];
            filteredMenu = filteredMenu.filter(
                (key) => !removedActions.includes(key),
            );
        }

        if (!item.userCanEdit || !item.displayInPortal) {
            filteredMenu = filteredMenu.filter((key) => key !== 'edit');
        }
        if (item.userCanEdit !== false) {
            filteredMenu = filteredMenu.filter((key) => key !== 'viewChanges');
        }

        return filteredMenu;
    }

    isAssetOwner(item: ResearcherAsset) {
        const owner = item.creators.find((creator) => creator.owner === true);
        if (owner?.id === this.jwtUtilService.getUserID()) {
            return true;
        }
        return false;
    }

    get isPublicPage() {
        return this.profileOutputService.isPublicPage();
    }

    displayNotifications(item) {
        if (!this.isPublicPage && item.notification) {
            return 1;
        }
        return 0;
    }

    getNotifications(item: ResearcherAsset) {
        return this.notificationService.setNoteData(item.notes, item.status);
    }

    exportAsset(item) {
        const dialogClosed = new Subject<null>();
        const xl8 = (key: string | string[], params?: Object) =>
            this.xl8Svc.instant(key, params);

        this.exportersService
            .showAssetExportDialog({
                dialogTitle: xl8(
                    'research.portal.fulldisplay.sendTo.export.title',
                ),
                dialogCancel: xl8(
                    'research.portal.fulldisplay.sendTo.export.close',
                ),
                labels: {
                    to: xl8('research.portal.fulldisplay.sendTo.export.to'),
                    copy: xl8('research.portal.fulldisplay.sendTo.export.copy'),
                    copied: xl8(
                        'research.portal.fulldisplay.sendTo.export.copy.success',
                    ),
                },
                selectedAssets: [
                    {
                        id: item.mmsId,
                        title: item.esploroRecord?.title,
                        type: xl8('portal.' + item.type),
                    },
                ],
                allAssets: this.profileOutputService.fullMMSList,
                selectedScope: 'single',
                exportTargets$: this.assetExportSvc.exportTargets$.pipe(
                    map((_) => _.filter((t) => t.value !== 'print')),
                ),
            })
            .pipe(takeUntil(dialogClosed))
            .subscribe((change) => {
                if (change.event === 'actionClick') {
                    this.assetExportSvc.handleExportActionClick(change, [
                        item.mmsId,
                    ]);
                }
                if (change.event === 'dialogClosed') {
                    this.assetExportSvc.clearOutput();
                    dialogClosed.next(null);
                    dialogClosed.complete();
                    this.briefElem().menuBtn().focus();
                }
            });
    }

    unhideAsset(item) {
        this.profileOutputService
            .unhideAssetOnPublicProfile(item.mmsId)
            .subscribe(() => {
                this.changePublicProfileVisibility(item, true);
            });
    }

    hideAsset(item, index) {
        setTimeout(() => {
            this.showgHideAssetDialo(item)
                .afterClosed()
                .pipe(take(1))
                .subscribe((response) => {
                    this.briefElem().menuBtn().focus();
                    if (response === 'ok') {
                        this.profileOutputService
                            .hideAssetFromPublicProfile(item.mmsId)
                            .subscribe(() => {
                                this.changePublicProfileVisibility(item, false);

                                // If asset is in highlight --> delete it
                                if (this.inHighlightsList(item)) {
                                    let assetIndex = -1;
                                    if (this.facet === 'highlights') {
                                        assetIndex = index;
                                    }
                                    this.removeHighlight(item.mmsId, index);
                                }
                            });
                    }
                });
        }, 0);
    }

    showgHideAssetDialo(item) {
        const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
            data: {
                title: 'research.output.list.hide.confirmation.title',
                message: this.inHighlightsList(item)
                    ? 'research.output.list.hide.confirmation.message.highlight'
                    : 'research.output.list.hide.confirmation.message',
                actions: {
                    cancel: 'research.output.list.hide.confirmation.cancel',
                    confirm: 'research.output.list.hide.confirmation.confirm',
                },
                actionFocus: 'confirm',
            },
        });
        dialogRef
            .afterClosed()
            .subscribe(() => this.briefElem().menuBtn().focus());
        return dialogRef;
    }

    changePublicProfileVisibility(item, visibility: boolean) {
        item.visibleInPublicProfile = visibility;
        item.menu = this.getMenu(item);
    }

    showHighlightButton(item) {
        return (
            !this.isPublicPage &&
            this.isPublishedAsset(item) &&
            (!item.isAssetSuppressed || this.inHighlightsList(item)) &&
            (item.visibleInPublicProfile || this.inHighlightsList(item))
        );
    }

    inHighlightsList(item) {
        if (
            this.profileOutputService.highlights &&
            this.profileOutputService.highlights.indexOf(item.mmsId) !== -1
        ) {
            return true;
        }
        return false;
    }

    getHighlightsTooltip(item) {
        if (this.inHighlightsList(item)) {
            return 'research.output.list.highlight.remove.tooltip';
        }
        return 'research.output.list.highlight.add.tooltip';
    }

    getNotificationActions() {
        const actions = [
            { code: 'reply', name: 'research.output.list.message.alert.reply' },
            { code: 'gotIt', name: 'research.output.list.message.alert.gotit' },
        ];
        return actions;
    }

    isTitleClickable() {
        return this.authorizationService.isAuthorizedForDeposit();
    }

    openApcForm(item) {
        this.router.navigate(['/apc'], {
            state: { asset: item },
            relativeTo: this.route,
            queryParams: { institution: this.institutionCode },
        });
    }

    getAssetStatusToDisplay(item) {
        if (item.assetStatus === 'pending_approval') {
            return 'research.output.list.status.pendingApproval';
        }
        return item.assetStatus;
    }

    navigateToFullAssetPage(
        url: string,
        isEditMode = false,
        isViewChangesMode = false,
    ) {
        const queryParams: Params = { institution: this.institutionCode };
        if (isEditMode) {
            queryParams['mode'] = 'edit';
        } else if (isViewChangesMode) {
            queryParams['mode'] = 'viewchanges';
        }
        this.router.navigate([url], { queryParams });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.assetListSubscription) {
            this.assetListSubscription.unsubscribe();
        }
    }
}
